var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2617 5.93245C25.2851 5.50879 25.1212 5.13219 24.8637 4.84975C24.5827 4.54377 24.1613 4.37901 23.7399 4.37901L13.2277 4.35547C13.0872 4.35547 12.8999 4.37901 12.7595 4.47315L7.21071 10.075C7.1873 10.0985 7.1873 10.0985 7.16389 10.1221C7.04682 10.3103 7 10.4751 7 10.6634V25.8684C7 26.7157 7.70237 27.4218 8.54522 27.4218H23.7399C24.5827 27.4218 25.2851 26.7157 25.2851 25.8684L25.2617 5.93245ZM23.4121 25.5388H8.87299V11.652H12.5956C13.5321 11.652 14.2578 10.9223 14.2578 9.98083L14.2344 6.26197H23.4121V25.5388Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8633 16.3594C10.8633 16.8772 11.2847 17.2773 11.7764 17.2773H20.4624C20.9774 17.2773 21.3755 16.8536 21.3755 16.3594C21.3755 15.8415 20.954 15.4414 20.4624 15.4414H11.7998C11.2847 15.4414 10.8633 15.8651 10.8633 16.3594Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4608 19.6309H13.9287C13.4136 19.6309 13.0156 20.0545 13.0156 20.5488C13.0156 21.0666 13.437 21.4667 13.9287 21.4667H20.4608C20.9758 21.4667 21.3739 21.0431 21.3739 20.5488C21.3973 20.031 20.9758 19.6309 20.4608 19.6309Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGms);
export default __webpack_public_path__ + "static/media/gms.bc2fd4775988659c727c90024d9ed47e.svg";
export { ForwardRef as ReactComponent };